import KValidationProvider from "./KValidationProvider";
import { VTextField } from "vuetify/lib";

export default VTextField.extend( {
	name: "KTextField",

	mixins: [ KValidationProvider ],

	props: {
		color: {
			default: "link",
			type: String
		},
		maxLength: Number
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VTextField.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		}
	},

	methods: {
		genValidatableField( props ) {
			return <VTextField
				attrs={{
					...this.$attrs,
					...this.propsToPass,
					errorMessages: props.errors
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</VTextField>;
		}
	},

	render() {
		return this.genValidationProvider();
	}
} );
